import { MODAL_CLOSE, MODAL_OPEN } from "./types";

const initialState = { type: undefined, props: undefined };

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_OPEN:
      return { type: action.modalType, props: action.modalProps || {} };
    case MODAL_CLOSE:
      return initialState;
    default:
      return state;
  }
};

export default modalReducer;
